import React from 'react';
import { Link } from 'react-router-dom';
import { GiWheat } from 'react-icons/gi';
import { FiInstagram } from 'react-icons/fi';
import CustomerVisitBadge from './CustomerVisitBadge';

export default function Footer() {
  return (
    <>
      <CustomerVisitBadge />
      <footer className="bg-[#063d25] text-white pt-10 sm:pt-14">
        <div className="max-w-7xl mx-auto px-5 sm:px-6">
        <div className="relative overflow-hidden rounded-[28px] border border-white/15 bg-[#0b5634]">
          <img
            src="/footer-farm-landscape.png"
            alt="Farmers and animals in a green field at sunrise"
            className="h-32 w-full object-cover sm:h-44 md:h-52"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#05371f]/90 via-[#05371f]/40 to-transparent" />
          <div className="absolute inset-0 flex max-w-xl flex-col justify-center px-6 sm:px-10">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-green-100 sm:text-sm">From the Farm, Straight to You</p>
            <h2 className="mt-1 text-xl font-bold leading-tight sm:mt-2 sm:text-3xl">Fresh food, fair prices, stronger farmers.</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-10 py-11 sm:grid-cols-2 lg:grid-cols-[1.25fr_1fr_0.8fr] lg:gap-14">
          <div>
            <div className="flex items-center gap-2.5">
              <GiWheat className="text-3xl text-green-200" />
              <span className="text-2xl font-bold tracking-tight">Sedyam</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-green-100">
              Fresh, traceable farm produce delivered directly from verified farmers to your home.
            </p>
            <Link
              to="/join-us"
              className="mt-5 inline-flex items-center justify-center rounded-full border border-green-200/50 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-white hover:text-green-800"
            >
              Join us as a farmer
            </Link>
          </div>

          <div>
            <h4 className="text-base font-semibold">Company & policies</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-green-100">
              <li><Link to="/terms-and-conditions" className="transition hover:text-white">Terms and Conditions</Link></li>
              <li><Link to="/privacy-policy" className="transition hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/shipping-policy" className="transition hover:text-white">Shipping Policy</Link></li>
              <li><Link to="/cancellation-and-refunds" className="transition hover:text-white">Cancellation and Refunds</Link></li>
              <li><Link to="/contact-us" className="transition hover:text-white">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold">Connect with us</h4>
            <a
              href="https://www.instagram.com/sedyam.live/"
              target="_blank"
              rel="noreferrer"
              aria-label="Follow Sedyam on Instagram"
              className="mt-4 inline-flex items-center gap-3 rounded-full border border-white/20 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-white hover:text-green-800"
            >
              <FiInstagram className="text-xl" />
              @sedyam.live
            </a>
            <p className="mt-5 text-sm text-green-100">sedyam.admin@gmail.com</p>
            <p className="mt-2 text-sm text-green-100">FSSAI No. 23626041000908</p>
          </div>
        </div>
        </div>

        <div className="border-t border-white/15 px-5 py-5 text-center text-xs text-green-200 sm:text-sm">
          Copyright 2026 VNS Sedyam Pvt Ltd. All rights reserved.
        </div>
      </footer>
    </>
  );
}
